'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AllowPayload(kind) {
  this.L9 = null;
  this.L9 = kind;
}
export { $c_Lpresto_types$AllowPayload as $c_Lpresto_types$AllowPayload };
$p = $c_Lpresto_types$AllowPayload.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AllowPayload;
/** @constructor */
function $h_Lpresto_types$AllowPayload() {
}
export { $h_Lpresto_types$AllowPayload as $h_Lpresto_types$AllowPayload };
$h_Lpresto_types$AllowPayload.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$AllowPayload)) {
    var x = this.L9;
    var x$2 = x$0.L9;
    return (x === x$2);
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "AllowPayload";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.L9;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.Hj = (function() {
  return this.L9;
});
function $isArrayOf_Lpresto_types$AllowPayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.js)));
}
export { $isArrayOf_Lpresto_types$AllowPayload as $isArrayOf_Lpresto_types$AllowPayload };
var $d_Lpresto_types$AllowPayload = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AllowPayload, "presto.types$AllowPayload", ({
  js: 1,
  d9: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$AllowPayload as $d_Lpresto_types$AllowPayload };
//# sourceMappingURL=presto.types$-Allow-Payload.js.map
